import type { ReactElement } from "react";
import { SchalterFeld, feldId } from "./felder.js";
import { mitWert, wertAn } from "../layoutEntwurf.js";
import type { PanelProps } from "../LayoutRegister.js";

/** Register „Blöcke": die Schalter des Katalogs. Ein Block zeigt sich nur, wenn der Beleg
 *  auch Inhalt dafür hat — der Schalter kann ihn nur unterdrücken. */
export function BloeckePanel(p: PanelProps): ReactElement {
  return (
    <div className="lay__panel">
      <p className="lay__panelhinweis">Ein Block erscheint nur, wenn der Beleg Inhalt dafür
        hat; abgeschaltet bleibt er immer weg.</p>
      {p.stand.katalog.bloecke.map((b) => (
        <SchalterFeld key={b.id} id={feldId(`bloecke.${b.id}`)} label={b.label}
          wert={wertAn(p.entwurf, ["bloecke", b.id])} systemwert={b.wert}
          fehler={p.feldFehler[`bloecke.${b.id}`]}
          onWert={(neu) => {
            p.onEntwurf(mitWert(p.entwurf, ["bloecke", b.id], neu));
            p.onFeldVerlassen();
          }} />
      ))}
    </div>
  );
}
